<template>
  <div class="box box--secondary mrgt+">
    <div class="media">
      <div class="media__left">
        <Icon id="info" class="icon--150 text-brand" />
      </div>
      <div class="media__body">
        <h4 class="mrgt0">{{ gettext('Déjà client Energiapro?') }}</h4>
        <div class="text-medium text-muted mrgb-">
          {{
            gettext(
              'Nous vous recommandons de continuer dans l’Espace client afin de vous baser sur votre consommation historique.'
            )
          }}
        </div>
        <a
          :href="`https://my.energiapro.ch/espace-client/views/view.login.php?form=biogaz_simulateur&usage=${usageId}`"
          class="text-bold text-medium"
        >
          {{ gettext('Vers l’Espace client')
          }}<Icon id="chevron-right" class="icon--75 mrgl--" />
        </a>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useSimulation } from '@/composables/useSimulation';

const { usageId } = useSimulation();
</script>
